<template>
  <div></div>
</template>
<script>
import { LINE_PATH_CONFIG } from "../../utils/mapSettings";

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    path: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      line: null,
    };
  },

  mounted() {
    this.line = new this.google.maps.Polyline({
      path: this.path,
      map: this.map,
      ...LINE_PATH_CONFIG,
    });
  },
  methods: {
    clearLine() {
      this.line.setMap(null);
    },
  },
};
</script>
